import React, { useState, useEffect } from "react";
import { Modal, Progress } from "antd";
import { LoaderContainer, TipContainer, MainMessage, SubMessage, IconContainer, StepIndicator, TimeEstimate } from "./styles.js";

const QuotationLoader = ({ isVisible, onClose }) => {
	const [currentTip, setCurrentTip] = useState(0);
	const [progress, setProgress] = useState(0);
	const [currentStep, setCurrentStep] = useState(0);
	const [timeRemaining, setTimeRemaining] = useState(30);

	const tips = [
		"💡 El número de motor se encuentra grabado en el block del motor",
		"🔍 El número de chasis está en el chasis del vehículo, lado derecho",
		"📋 Tené a mano la cédula verde para completar los datos",
		"⚡ Estamos comparando precios en las mejores aseguradoras",
		"🎯 Buscamos la cotización que mejor se adapte a tu perfil",
		"📞 Pronto te contactaremos para finalizar tu póliza",
		"🚗 Verificamos coberturas específicas para tu vehículo"
	];

	const steps = [
		"Analizando datos del vehículo...",
		"Consultando aseguradoras...",
		"Comparando coberturas...",
		"Finalizando cotización..."
	];

	useEffect(() => {
		if (!isVisible) {
			setProgress(0);
			setCurrentTip(0);
			setCurrentStep(0);
			setTimeRemaining(30);
			return;
		}

		// Rotar tips cada 4 segundos
		const tipInterval = setInterval(() => {
			setCurrentTip((prev) => (prev + 1) % tips.length);
		}, 4000);

		// Simular progress cada 800ms
		const progressInterval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 95) return prev; // No llegar al 100% hasta que termine realmente
				const newProgress = prev + Math.random() * 8 + 2; // Incremento variable entre 2-10%
				
				// Actualizar step basado en progreso
				if (newProgress > 75) setCurrentStep(3);
				else if (newProgress > 50) setCurrentStep(2);
				else if (newProgress > 25) setCurrentStep(1);
				else setCurrentStep(0);
				
				return newProgress;
			});
		}, 800);

		// Countdown timer
		const timeInterval = setInterval(() => {
			setTimeRemaining((prev) => Math.max(0, prev - 1));
		}, 1000);

		return () => {
			clearInterval(tipInterval);
			clearInterval(progressInterval);
			clearInterval(timeInterval);
		};
	}, [isVisible, tips.length]);

	// Completar progress cuando se cierra el modal
	useEffect(() => {
		if (!isVisible && progress > 0) {
			setProgress(100);
		}
	}, [isVisible, progress]);

	return (
		<Modal
			open={isVisible}
			closable={false}
			footer={null}
			centered
			width={450}
			maskClosable={false}
		>
			<LoaderContainer>
				<MainMessage>
					Buscando la mejor cotización
				</MainMessage>
				
				<StepIndicator>
					{steps[currentStep]}
				</StepIndicator>
				
				<Progress 
					percent={Math.round(progress)} 
					strokeColor={{
						'0%': '#1890ff',
						'100%': '#52c41a',
					}}
					strokeWidth={6}
					showInfo={false}
					trailColor="#f5f5f5"
				/>
				
				<TimeEstimate>
					⏱️ {timeRemaining}s restantes
				</TimeEstimate>
				
				<TipContainer>
					<p>{tips[currentTip]}</p>
				</TipContainer>
			</LoaderContainer>
		</Modal>
	);
};

export default QuotationLoader;
